const binding = { modules: {}, dataActions: {} };

    (binding.modules['catalog-cookie'] = {
        c: () => require('partner/modules/catalog-cookie/catalog-cookie.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'catalog-cookie',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/catalog-cookie'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };